import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { DataProfileState } from "./model";

let state: DataProfileState = {
  dataProfiles: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<DataProfileState, RootStateType>;
